import WizardStepPage from './WizardStepPage';

/** Step 6 — Day-by-day itinerary builder */
const ItinerariesStep = (props) => (
    <WizardStepPage
        stepKey="itineraries"
        isStepDataLoading={props.isStepDataLoading}
        formData={props.formData?.itineraries}
        onChange={props.onChange}
        errors={props.errors}
        setErrors={props.setErrors}
        duration={props.formData?.packages?.duration || 0}
        itineraryDays={props.formData?.itineraries?.days || []}
        onDayChange={props.onDayChange}
        onAddLineItem={props.onAddLineItem}
        onLineItemChange={props.onLineItemChange}
        onRemoveLineItem={props.onRemoveLineItem}
        tripComponents={props.tripComponents}
        onNewComponent={props.onNewComponent}
        onSearchExistingComponent={props.onSearchExistingComponent}
        tripCurrency={props.tripCurrency}
    />
);

export default ItinerariesStep;
